<main [cdkTrapFocus]="isTrapActive" cdkTrapFocusAutoCapture class="layout-panel-centered">
  <form [formGroup]="step2" class="panel overflowing">
    <header class="panel-header">
      <h1 class="sr-only" i18n="sr-only@@profile.setupRecipientProfileDetails.title">Registrierungsprozess</h1>
      <ol aria-label="Schritte" class="process-steps heading">
        <li class="completed d-none d-sm-flex"><a i18n="@@profile.setupGiverOffer.profile"
        routerLink="/on-boarding/recipient-profile">1. Profil</a></li>
        <li class="completed"><a aria-current="step" i18n="@@profile.setupGiverOffer.information"
        routerLink="/on-boarding/recipient-profile-details">2. Angaben</a></li>
        <li class="d-none d-sm-flex" i18n="@@profile.setupGiverOffer.assistance">3. Assistenz</li>
      </ol>
      <a class="cancel" i18n="@@profile.setupGiverOffer.btn.cancel" routerLink="/">Abbrechen</a>
    </header>
    <div class="panel-content transportation-illustration">
      <p class="text" i18n="@@profile.setupRecipientProfileDetails.info.step2Info">
                Um Sie mit passenden persönlichen Assistentinnen und Assistenten in Verbindung zu bringen, brauchen wir
                einige Angaben von Ihnen. Diese Angaben sind nicht öffentlich zugänglich.
            </p>

      <app-recipient-profile-details [form]="form" [parentGroup]="step2"></app-recipient-profile-details>

      <div class="panel-section">
        <p class="text" i18n="@@profile.setupRecipientProfileDetails.info.moreDetails">
                    Um die CléA Assistenzplattform nutzen zu können, muss man unterschriftsberechtigt sein.
                </p>

        <div class="grid">
          <div class="span-12">
            <div class="form-check">
              <input formControlName="authorizedToSign" id="input-authorized-to-sign" type="checkbox"/>
              <label class="label" for="input-authorized-to-sign">
                <ng-container i18n="@@profile.setupRecipientProfileDetails.checkbox.authorizedToSign">
                                    Ich bin unterschriftsberechtigt
                                </ng-container>
                <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
              </label>
            </div>
            @if (authorizedToSign.invalid && (authorizedToSign.touched || authorizedToSign.dirty)) {
              <div
                class="validation error"
                i18n="@@profile.setupRecipientProfileDetails.error.authorizedToSign">Bitte bestätigen Sie,
                            dass Sie unterschriftsberechtigt sind.
                        </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <button (click)="back()" class="button block-xs" i18n="@@profile.setupGiverOffer.btn.back" type="button">
                Zurück
            </button>
      <button (click)="next()" class="button primary block-xs" i18n="@@profile.setupGiverOffer.btn.next"
        type="button">Weiter
            </button>
    </div>
  </form>
</main>
